import crypto from "crypto";
import FJMedia from "../store/FJMedia";
import FJConfig from '../config/FJConfig';
import $ from 'jquery';
import FJVideoManager from "../core/FJVideoManager";
import FJCoreUtil from "../core/util/FJCoreUtil";
// import FJLocalStore from "../store/FJLocalStore";
import FileSaver from 'file-saver'
import key from 'keymaster'
import 'popper.js'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import paper from "paper";
import FJEventConstant from "../constant/FJEventConstant";
import FJCanvasStore from "../store/FJCanvasStore";
import FJErrorConstant from "../constant/FJErrorConstant";
import FJViewConstant from "../constant/FJViewConstant";
import FJRatioStore from "../store/FJRatioStore";

/**
 * @class FJUtil
 * @classdesc 通用辅助函数对象
 */
let FJUtil = (function () {

  const maxThumbnailCacheCount = 0;
  let _thumbnailQueue = [];
  let _isThnmnailWorking = false;
  let _thumbnailCache = {}; // 视频缩略图缓存
  let _scope = '';
  let auxiliary = null;

  (new paper.Project()).activate();

  function getFitRect(outerSize, innerSize) {
    // eslint-disable-next-line babel/no-invalid-this
    let size = FJCoreUtil.fitSize(
      {width: outerSize.width, height: outerSize.height},
      {width: innerSize.width, height: innerSize.height});
    let x = (outerSize.width - size.width) / 2;
    let y = (outerSize.height - size.height) / 2;
    return {
      x,
      y,
      width: size.width,
      height: size.height,
    }
  }

  return {

    /**
     * @description tooltip显示
     * @param name
     * @param position
     * @param options
     */
    allTooltip: function (name, position, options = {}) {
      let $ele = $('.' + name);
      $ele.each(function () {
        let localValue = this.getAttribute('tooltip');
        if (localValue) {
          this.setAttribute('data-original-title', localValue);
          $(this).tooltip({
            delay: {"show": 200, "hide": 100},
            trigger: "hover",
            placement: position,
            container: 'body',
            boundary: 'body',
            ...options,
          });
        }
      });
    },
    toggleTooltip: function (element, toggle) {
      $(element).tooltip(toggle ? 'show' : 'hide');
    },
    oneTooltip: function (obj, position, options = {}) {
      if (!obj) return;
      let localValue = obj.getAttribute('tooltip');
      if (localValue) {
        obj.setAttribute('data-original-title', localValue);
        $(obj).tooltip({
          delay: {"show": 200, "hide": 100},
          trigger: "hover",
          placement: position,
          container: 'body',
          ...options,
        });
      }
    },
    disableToolTip: function (obj) {
      $(obj).tooltip('disable');
    },
    enableToolTip: function (obj) {
      $(obj).tooltip('enable');
    },

    /**
     * @description 返回资源的hash值
     * @param {File} source
     * @return {Promise<string>}
     */
    hashEncode: async function (source) {
      let threshold = 1048576; // 1M
      let chunk = source;
      let size = chunk.size ? chunk.size : chunk.length;
      if (size > threshold) {
        let offset = 0;// Math.floor((size - threshold)/2);
        chunk = source.slice(offset, offset + threshold);
      }

      let arrayBuffer;
      if (chunk.arrayBuffer) {
        arrayBuffer = await chunk.arrayBuffer();
      } else {
        arrayBuffer = await FJCoreUtil.convertToArrayBuffer(chunk);
      }
      let hash = crypto.createHash('sha256');
      let buffer = this.arrayBufferToBuffer(arrayBuffer);
      hash.update(buffer);
      return hash.digest('hex');
    },

    /**
     * @description arrayBuffer
     * @param arrayBuffer
     * @returns {ArrayBuffer}
     */
    arrayBufferToBuffer: function (arrayBuffer) {
      let buffer = Buffer.alloc(arrayBuffer.byteLength);
      let view = new Uint8Array(arrayBuffer);
      for (let i = 0; i < buffer.length; ++i) {
        buffer[i] = view[i];
      }
      return buffer;
    },

    /**
     * @description 返回文件类型
     * @param {File} file
     * @return {MEDIA_TYPE}
     */
    getFileType: function (file) {
      let type = file.type;
      let {VIDEO, IMAGE, AUDIO} = FJMedia.MediaType();
      if (type.includes('image')) {
        return IMAGE;
      } else if (type.includes('video')) {
        return VIDEO;
      } else if (type.includes('audio')) {
        return AUDIO;
      }
    },

    /**
     * @description 创建音频视频 DOM
     * @param file
     * @returns {Promise<unknown>}
     */
    checkMediaDurationSupport: async function (file) {
      let type = file.type;
      if (type.split('/')[0] === 'image') {
        return true;
      }
      try {
        let {duration} = await FJUtil.getVideoInfoWithUrl(URL.createObjectURL(file));
        return duration >= FJConfig.minLimitTime;
      } catch (e) {
        return true;
      }
    },

    /**
     * @description 拖拽文件上传触发
     * @param e
     * @param props
     * @param callback
     */
    onFileDrop: function (e, props, callback) {
      // 触发body上的mousedown事件，使下拉框弹回
      // 处理二级下拉需要触发两次
      FJCoreUtil.triggerEvent(document.body, 'mousedown');
      FJCoreUtil.triggerEvent(document.body, 'mousedown');

      let {mediaOverSize, mediaOverNum, mediaNotSupport, mediaDuration, onDataChange, type} = props;

      // 复制的目的是避免input值修改后造成e.target.files值改变的情况
      let files = Array.prototype.slice.call((e.dataTransfer && e.dataTransfer.files) || e.target.files, 0);
      let length = files.length;
      let continueType = false;

      if (length === 0) {
        return;
      } else {
        e.stopPropagation();
        e.preventDefault();
      }

      async function func() {
        try {
          let sizeErrorFileList = [];
          let typeNotSupportFileList = [];
          let uploadFileList = [];

          for (let i = 0; i < length; i++) {
            let file = files[i];

            if (!await FJUtil.checkMediaDurationSupport(file) && mediaDuration) {
              if (!continueType) {
                mediaDuration((backType) => {
                  if (backType === 'cancel') {
                    if (callback) {
                      callback();
                    }
                  } else if (backType === 'continue') {
                    continueType = true;
                    func();
                  }
                });
                return;
              } else {
                continue;
              }
            }
            // 判断文件大小
            if (file.size / (1024 * 1024) > FJConfig.mediaMaxSize) {
              sizeErrorFileList.push(file);
            }

            // 判断文件格式
            let canSupport = false;
            if (Array.isArray(type)) {
              canSupport = !type.every(t => file.type.indexOf(t) === -1);
            } else if (typeof type === 'string') {
              canSupport = file.type.indexOf(type) !== -1
            }

            if (!canSupport) {
              console.log(file)
              typeNotSupportFileList.push(file);
            }

            uploadFileList.push(file);
          }

          if (sizeErrorFileList.length > 0 && mediaOverSize) {
            mediaOverSize();
            if (callback) {
              callback();
            }
            return;
          }

          if (typeNotSupportFileList.length > 0 && mediaNotSupport) {
            mediaNotSupport();
            if (callback) {
              callback();
            }
            return;
          }

          if (onDataChange) {
            onDataChange(uploadFileList);
            if (callback) {
              callback();
            }
          }
        } catch (e) {
          console.log(e);
          mediaNotSupport();
          if (callback) {
            callback();
          }
        }
      }


      // 判断上传数量
      if (length > FJConfig.maxUploadCount && mediaOverNum) {
        mediaOverNum((backType) => {
          if (backType === 'cancel') {
            if (callback) {
              callback();
            }
          } else if (backType === 'continue') {
            length = FJConfig.maxUploadCount;
            func();
          }
        });
        return;
      }

      func();
    },

    /**
     * @default 将输入的文字转换为大写，过滤介词
     * @param {string} str
     * @return {string}
     */
    upperWord: function (str) {
      if (!str) {
        return ''
      }
      const prepositionList = [
        'and',
        'of',
        'with',
        'for',
        'in',
        'on',
        'to',
        'by',
        'from',
        'but',
        'after',
        'back',
        'the',
        'along',
        'as',
        'a',
        'an',
        'over',
        'at',
      ];
      let arr = str.split(' ');
      let arrLength = arr.length;
      return arr.map((word, index) => {
        let lowerWorld = word.toLowerCase();
        return prepositionList.indexOf(word) === -1 || index === 0 || index === arrLength - 1
          ? this.upperFirstLetter(lowerWorld) : lowerWorld
      }).join(' ');
    },

    /**
     * @description 对有后缀名的名称进行截取
     * @param name
     * @param fontSize
     * @param maxWidth
     * @returns {string|{fileText: string, fileName: string}}
     */
    getEspText: function (name, fontSize, maxWidth) {
      if (!name || typeof name !== 'string') {
        return '';
      }
      let fileName = name.slice(name.lastIndexOf("\\") + 1);
      let fileExt = fileName.replace(/.+\./, "");
      let filePureName = fileName.replace('.' + fileExt, "");
      let fontObj = {
        fontName: "Roboto-Regular,Roboto",
        fontSize: fontSize,
        fontStyle: '',
        fontWeight: '',
      };
      let extWidth = this.getTextSize(fileExt, fontObj).width;
      let nameWidth = this.getTextSize(name, fontObj).width;
      let fileText = name;
      let lastChar = filePureName[filePureName.length - 1];
      let newMaxWidth = maxWidth - extWidth;

      if (newMaxWidth > 0 && nameWidth > 0 && nameWidth >= newMaxWidth) {
        fileText = filePureName;
        fileText = fileText.length > 100 ? fileText.slice(0, 50) : fileText;
        while (this.getTextSize(fileText, fontObj).width >= newMaxWidth
        || this.getTextSize(fileText + '...', fontObj).width >= newMaxWidth) {
          fileText = fileText.slice(0, fileText.length - 1);
        }

        fileText = fileText.slice(0, fileText.length - 1) + '...' + lastChar + '.' + fileExt;
      }
      return {
        fileName: fileName,
        fileText: fileText,
      }
    },

    /**
     * @description 得到width
     * @param string
     * @param fontObj
     * @returns {{}}
     */
    getTextSize: function (string = '', fontObj) {
      let style = "normal";
      let weight = "normal";
      if (fontObj.fontStyle)
        style = fontObj.fontStyle;
      if (fontObj.fontWeight)
        weight = fontObj.fontWeight;
      let div = document.getElementById('textWidthPlaceholder');
      let text;
      let block;
      if (!div) {
        div = $('<div id="textWidthPlaceholder"  style="position: absolute; z-index: -1"></div>');
        block = $('<div style="display: inline-block; width: 1px; height: 0;"></div>');
        text = $(document.createElement('span'));
        $(div).append(text, block);
        $(document.body).append(div);
      } else {
        text = $($(div).find('span')[0]);
        block = $($(div).find('div')[0]);
      }

      text.css({
        'font-family': fontObj.fontName,
        'font-size': fontObj.fontSize,
        'font-style': style,
        'font-weight': weight,
        "white-space": "nowrap"
      });
      text[0].innerHTML = 'gh';

      let result = {};
      let scale = 1.0;
      block.css({verticalAlign: 'baseline'});
      result.ascent = (block.offset().top - text.offset().top) * scale;

      block.css({verticalAlign: 'bottom'});
      result.height = $(text).height();
      result.descent = result.height - result.ascent;
      text[0].innerHTML = string.replace(/ /g, '&nbsp;');
      result.width = $(text).width();
      return result;
    },

    /**
     * @description 得到视频的metadata信息
     * @param url
     * @returns {Promise<unknown>}
     */
    getVideoInfoWithUrl: function (url) {
      return new Promise((resolve, reject) => {
        let video = document.createElement('video');

        function addEvent() {
          FJCoreUtil.addEvent(video, 'loadeddata', onLoaded);
          FJCoreUtil.addEvent(video, 'error', onError);
        }

        function removeEvent() {
          FJCoreUtil.removeEvent(video, 'loadeddata', onLoaded);
          FJCoreUtil.removeEvent(video, 'error', onError);
          video.src = '';
          video = null;
        }

        function onLoaded() {
          let {videoWidth, videoHeight, duration} = video;
          // 流媒体无法通过metadata获取时长
          if (duration === Infinity) {
            video.currentTime = 1e10;
            video.ondurationchange = () => {
              duration = video.duration;
              video.ondurationchange = null;
              removeEvent();
              resolve({
                duration: duration,
                width: videoWidth,
                height: videoHeight
              });
            }
          } else {
            removeEvent();
            resolve({
              duration: duration,
              width: videoWidth,
              height: videoHeight
            });
          }
        }

        function onError() {
          removeEvent();
          reject(new Error('getVideoDurationWithUrl error'));
        }

        addEvent();
        video.src = url;
        video.load();
      });
    },

    /**
     * @description 得到音频的时长
     * @param url
     * @returns {Promise<unknown>}
     */
    getAudioDurationWithUrl: function (url) {
      return new Promise((resolve, reject) => {
        let audio = document.createElement('audio');

        function addEvent() {
          FJCoreUtil.addEvent(audio, 'loadeddata', onLoaded);
          FJCoreUtil.addEvent(audio, 'error', onError);
        }

        function removeEvent() {
          FJCoreUtil.removeEvent(audio, 'loadeddata', onLoaded);
          FJCoreUtil.removeEvent(audio, 'error', onError);
        }

        function onLoaded() {
          let duration = audio.duration;
          removeEvent();
          resolve(duration);
        }

        function onError() {
          removeEvent();
          reject(new Error('getAudioDurationWithUrl error'));
        }

        addEvent();
        audio.src = url;
      });
    },

    /**
     * @description 渲染图片缩略图
     * @param canvas
     * @param url
     * @return {Promise<unknown>}
     */
    renderImageThumbnail: function (canvas, url) {
      return new Promise((resolve, reject) => {
        let image = new Image();

        function releaseImage() {
          image.src = '';
          image = null;
        }

        function addEvent() {
          FJCoreUtil.addEvent(image, 'load', onLoaded);
          FJCoreUtil.addEvent(image, 'error', onError);
        }

        function removeEvent() {
          FJCoreUtil.removeEvent(image, 'load', onLoaded);
          FJCoreUtil.removeEvent(image, 'error', onError);
        }

        function onLoaded() {
          // eslint-disable-next-line babel/no-invalid-this
          let {width, height} = getFitRect.call(this, canvas, {
            width: image.naturalWidth,
            height: image.naturalHeight,
          });
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(image, 0, 0, width, height);

          removeEvent();
          releaseImage();
          resolve();
        }

        function onError() {
          removeEvent();
          releaseImage();
          reject(new Error('renderImageThumbnail error'));
        }

        addEvent();
        image.src = url;
      });
    },

    /**
     * @description 渲染视频首帧缩略图
     * @param canvas
     * @param url
     * @param videoInfo
     * @return {Promise<unknown>}
     */
    renderVideoCoverThumbnail: function (canvas, url, videoInfo) {
      return new Promise((resolve, reject) => {
        let video = document.createElement('video');

        function addEvent() {
          FJCoreUtil.addEvent(video, 'loadeddata', onLoaded);
          FJCoreUtil.addEvent(video, 'error', onError);
          FJCoreUtil.addEvent(video, 'seeked', onSeeked);
        }

        function removeEvent() {
          FJCoreUtil.removeEvent(video, 'loadeddata', onLoaded);
          FJCoreUtil.removeEvent(video, 'error', onError);
          FJCoreUtil.removeEvent(video, 'seeked', onError);
          video.src = '';
          video = null;
        }

        function onSeeked() {
          let {width, height} = getFitRect(canvas, {
            width: video.videoWidth,
            height: video.videoHeight,
          });
          canvas.width = width;
          canvas.height = height;
          FJCoreUtil.renderVideoToCanvasWithInfo(canvas, video, videoInfo);
          removeEvent();
          requestAnimationFrame(() => {
            resolve();
          });
        }

        function onLoaded() {
          video.currentTime = 0;
        }

        function onError() {
          removeEvent();
          requestAnimationFrame(() => {
            reject(new Error('renderVideoCoverThumbnail error'));
          });
        }

        addEvent();
        video.src = url;
        video.load();
      });
    },

    /**
     * @description 渲染视频缩略图
     * @param {element} canvas
     * @param {string} src
     * @param {object} zone
     * @param {number} zone.start,
     * @param {number} zone.end,
     * @param {object} videoInfo
     */
    renderVideoThumbnail: function (canvas, src, zone, videoInfo) {

      function initFrameData(videoSize) {
        if (!maxFrameCount) {
          frameSize = {
            width: Math.floor(videoSize.width / videoSize.height * canvas.height),
            height: canvas.height,
          };
          maxFrameCount = Math.ceil(canvas.width / frameSize.width);
        }
      }

      function videoSeeked() {

        setTimeout(() => {
          if (!active) {
            return;
          }

          if (curFrameCount >= maxFrameCount) {
            clearVideo();
          } else {
            let {start, end} = zone;
            let duration = end - start;
            let videoSize = {width: video.videoWidth, height: video.videoHeight};
            let contentSize = FJCoreUtil.fitSize(videoSize, frameSize);
            let renderRect = {
              sx: Math.abs(video.videoWidth - contentSize.width) / 2,
              sy: Math.abs(video.videoHeight - contentSize.height) / 2,
              sWidth: contentSize.width,
              sHeight: contentSize.height,
            };
            let previewRect = {
              dx: curFrameCount * frameSize.width,
              dy: 0,
              dWidth: frameSize.width,
              dHeight: frameSize.height,
            };
            let {sx, sy, sWidth, sHeight} = renderRect;
            let {dx, dy, dWidth, dHeight} = previewRect;
            let cacheId = src + curTime;
            if (!hasCache(cacheId)) {
              let cacheCanvas = document.createElement('canvas');
              cacheCanvas.width = dWidth;
              cacheCanvas.height = dHeight;
              FJCoreUtil.renderVideoToCanvasWithInfo(cacheCanvas, video, videoInfo, {
                clipRect: {x: sx, y: sy, width: sWidth, height: sHeight},
              });
              _thumbnailCache[cacheId] = {id: cacheId, canvas: cacheCanvas, videoSize};

              let keys = Object.keys(_thumbnailCache);
              if (keys.length > maxThumbnailCacheCount) {
                let deleteKey = keys.find(key => key !== cacheId);
                if (deleteKey) {
                  _thumbnailCache[deleteKey].canvas = null;
                  delete _thumbnailCache[deleteKey];
                }
              }
            }

            ctx.drawImage(_thumbnailCache[cacheId].canvas, dx, dy, dWidth, dHeight);

            curFrameCount++;
            if (curFrameCount === maxFrameCount - 1) {
              seekVideo(end);
            } else if (curFrameCount === maxFrameCount) {
              clearVideo();
            } else {
              let time = curTime + duration / (maxFrameCount - 1);
              if (!isNaN(time)) {
                seekVideo(time);
              }
            }
          }
        }, 0)
      }

      function videoLoaded() {
        initFrameData({width: video.videoWidth, height: video.videoHeight});
        seekVideo(curTime);
      }

      function clearVideo() {

        active = false;
        _isThnmnailWorking = false;
        FJCoreUtil.removeEvent(video, 'loadeddata', videoLoaded);
        FJCoreUtil.removeEvent(video, 'error', clearVideo);
        FJCoreUtil.removeEvent(video, 'seeked', videoSeeked);
        FJVideoManager.releaseVideo(video);

        setTimeout(() => {
          let nextItem = _thumbnailQueue.shift();
          if (nextItem) {
            let { canvas: nextCanvas, src: nextSrc, zone: nextZone, videoInfo: nextInfo } = nextItem;
            FJUtil.renderVideoThumbnail(nextCanvas, nextSrc, nextZone, nextInfo);
          }
        }, 200);
      }

      function hasCache(cacheId) {
        return !!_thumbnailCache[cacheId];
      }

      function seekVideo(time) {

        curTime = FJCoreUtil.toFixed(time, 2);
        let cacheId = src + curTime;
        if (hasCache(cacheId)) {
          initFrameData(_thumbnailCache[cacheId].videoSize);
          setTimeout(videoSeeked, 0);
        } else {
          if (video.src === src) {
            video.currentTime = curTime;
          } else {
            loadVideo();
          }
        }
      }

      function loadVideo() {
        FJCoreUtil.addEvent(video, 'loadeddata', videoLoaded);
        FJCoreUtil.addEvent(video, 'seeked', videoSeeked);
        video.src = src;
      }

      function removeExpiredWork() {
        let itemToDestroy = _thumbnailQueue.find(item => item.canvas === canvas);
        if (itemToDestroy) {
          FJCoreUtil.removeFromArray(_thumbnailQueue, itemToDestroy);
        }
      }

      if (_isThnmnailWorking) {
        removeExpiredWork();
        _thumbnailQueue.push({canvas, src, zone, videoInfo});
        return removeExpiredWork;
      }

      if (!canvas || canvas.width === 0 || canvas.height === 0) {
        return removeExpiredWork;
      }

      let ctx = canvas.getContext('2d');
      let frameSize = {};
      let maxFrameCount = 0;
      let curFrameCount = 0;
      let curTime = zone.start || 0.01;
      let active = true;
      let video = FJVideoManager.getVideo();

      seekVideo(zone.start || 0.1);

      _isThnmnailWorking = true;

      return clearVideo;
    },

    /**
     * @description 将秒 转化成 00：00格式
     * @param second
     * @param hasHour
     * @returns {*}
     */
    secondToInstant: function (second, hasHour) {
      if (!second) {
        return hasHour ? '00:00:00' : '00:00';
      }

      let s = second;
      let m;
      let h;

      let format = (value) => {
        return value < 10 ? '0' + value : value;
      };

      if (hasHour) {
        h = Math.floor(s / 3600);
        s -= h * 3600;
        m = Math.floor(s / 60);
        s -= m * 60;
        h = format(h);
        m = format(m);
        s = format(Math.floor(s));
        return `${h}:${m}:${s}`;
      } else {
        m = Math.floor(second / 60);
        s = s - m * 60;
        m = format(m);
        s = format(Math.floor(s));
        return `${m}:${s}`;
      }
    },

    /**
     * @description 偶数化数值
     * @param num
     * @return {number}
     */
    even: function (num) {
      return Math.floor(num) % 2 === 0 ? Math.floor(num) : Math.floor(num) - 1;
    },

    /**
     * @description 测试渲染DOM
     * @param view
     */
    testView: function (view) {
      document.body.appendChild(view);
      view.style.setProperty('position', 'fixed');
      view.style.setProperty('left', '0');
      view.style.setProperty('top', '0');
      view.style.setProperty('z-index', '999999999999999');
    },

    /**
     * @description 同步克隆节点
     * @param node
     * @return {*|ActiveX.IXMLDOMNode|Node}
     */
    cloneNodeSync: function (node) {
      let func = (cloneCanvas, canvas) => {
        if (cloneCanvas.width !== 0 && cloneCanvas.height !== 0 && canvas.width !== 0 && canvas.height !== 0) {
          cloneCanvas.getContext('2d').drawImage(canvas, 0, 0, canvas.width, canvas.height);
        }
        return cloneCanvas;
      };
      if (node.nodeName === 'CANVAS') {
        return func(node.cloneNode(true), node);
      } else {
        let clone = node.cloneNode(true);
        let canvases = $(node).find('canvas');
        let cloneCanvases = $(clone).find('canvas');
        let arr = [...canvases];
        let length = arr.length;
        for (let i = 0; i < length; i++) {
          func(cloneCanvases[i], arr[i]);
        }
        return clone;
      }
    },

    /**
     * @description 点击是否在区域内
     * @param e 鼠标点击对象
     * @param object 点击区域dom
     * @returns {boolean}
     */
    isPanelArea: function (e, object) {
      if (!e) {
        return false;
      }
      let point = {
        x: e.clientX,
        y: e.clientY,
      };

      try {
        let rect = {
          x: $(object).offset().left,
          y: $(object).offset().top,
          width: $(object).outerWidth(),
          height: $(object).outerHeight(),
        };

        return FJCoreUtil.isPointInRect(point, rect);
      } catch (e) {
        return false;
      }
    },

    /**
     * @description 创建svg标签
     * @param tag
     * @param attr
     * @returns {*}
     */
    createSvgElement: function (tag, attr) {
      if (!document.createElementNS) return;
      let $svg = $(document.createElementNS('http://www.w3.org/2000/svg', tag));
      for (let key in attr) {
        if (attr.hasOwnProperty(key)) {
          switch (key) {
            case 'xlink:href': // 文本路径添加属性特有
              $svg[0].setAttributeNS('http://www.w3.org/1999/xlink', key, attr[key]);
              break;
            default:
              $svg.attr(key, attr[key]);
          }
        }
      }
      return $svg[0];
    },

    /**
     * @description 获取链接中指定字段
     * @param name
     * @return {string|null}
     */
    getQueryString: function (name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r !== null) return unescape(r[2]);
      return null;
    },

    /**
     * @description 是否为匿名工程
     * @returns {boolean}
     */
    isAnonymousProject: function () {
      return this.isLocalhost() ? false : (this.getQueryString('id') ? !this.isLogin() : true);
    },

    /**
     * @description 设置标签标题
     * @param title
     */
    setDocumentTitle: function (title) {
      document.title = title + ' - FlexClip';
    },

    /**
     * @description 是否为本地开发环境
     * @return {boolean}
     */
    isLocalhost: function () {
      return Boolean(
        window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(
          /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        ) ||
        window.location.hostname.match(
          /^192.168(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){2}$/
        )
      );
    },

    /**
     * @description 下载录屏录像后的video
     * @param data
     * @param type
     * @param name
     */
    downloadFromRecord: function (data, type, name) {
      let mimeType = '';
      let extName = '';
      switch (type) {
        case 'video':
          mimeType = "video/webm";
          extName = 'webm';
          break;
        case 'image':
          mimeType = "image/png";
          extName = 'png';
          break;
        default:
      }
      let blob = new Blob([data], {type: mimeType});
      FileSaver(blob, name + "." + extName);
    },

    /**
     * @description blob 转 DataURL
     * @param blob
     * @returns {Promise<unknown>}
     */
    blobToDataURL: function (blob) {
      return new Promise((resolve, reject) => {
        let a = new FileReader();
        a.onload = function (e) {
          resolve(e.target.result);
        };
        a.onerror = function (e) {
          reject(e);
        };
        a.readAsDataURL(blob);
      });
    },

    /**
     * @description dataURL 转 File
     * @param dataurl
     * @param filename
     * @returns {File}
     */
    dataURLtoFile: function (dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },

    /**
     * @description 格式化时间
     * @param time
     * @returns {string}
     */
    formatTime: function (time) {
      let m = Math.floor(time / 60);
      let s = Math.floor(time % 60);
      if (s < 10)
        s = "0" + s;
      return m + ":" + s;
    },


    /**
     * @description 返回的当前使用的字体的路径
     * @param fontName
     * @returns {string}
     */
    getFontPreview: function (fontName) {
      if (!fontName) {
        return '';
      }
      return (FJConfig.fontPath + fontName.replace(/\s+/g, '-') + '/' + fontName.replace(/\s+/g, '-') + '.svg').toLowerCase() + '?v=' + window.AppVersion;
    },

    /**
     * @description 添加一个动画（以点击点为中心向外扩散的涟漪动画）
     * @param selector dom节点
     * @param options 配置参数s
     */
    rippleAnimationLite: function (selector, options) {
      if (options && options.duration) {
        options.duration = options.duration / 1000;
      }
      let self = this;
      self.selector = selector;
      self.defaults = {
        on: 'mousedown',
        opacity: 0.4,
        color: "auto",
        multi: false,
        duration: 0.7,
        rate: function (pxPerSecond) {
          return pxPerSecond;
        },
        easing: 'linear'
      };
      self.defaults = $.extend({}, self.defaults, options);
      let Trigger = function (e) {
        let $this = $(this);
        let $ripple;
        let settings;
        $this.addClass('has-ripple');
        // This instances settings
        settings = $.extend({}, self.defaults, $this.data());
        let size = Math.max($this.outerWidth(), $this.outerHeight());
        // Create the ripple element
        if (settings.multi || (!settings.multi && $this.find(".ripple").length === 0)) {
          $ripple = $("<span />").addClass("ripple");
          $ripple.appendTo($this);

          // Set ripple size
          if (!$ripple.height() && !$ripple.width()) {
            $ripple.css({
              height: size,
              width: size
            });
          }

          // Give the user the ability to change the rate of the animation
          // based on element width
          if (settings.rate && typeof settings.rate === "function") {

            // rate = pixels per second
            let rate = Math.round($ripple.width() / settings.duration);

            // new amount of pixels per second
            let filteredRate = settings.rate(rate);

            // Determine the new duration for the animation
            let newDuration = ($ripple.width() / filteredRate);

            // Set the new duration if it has not changed
            if (settings.duration.toFixed(2) !== newDuration.toFixed(2)) {
              settings.duration = newDuration;
            }
          }

          // Set the color and opacity
          let color = (settings.color === "auto") ? $this.css('color') : settings.color;
          let css = {
            animationDuration: (settings.duration).toString() + 's',
            animationTimingFunction: settings.easing,
            background: color,
            opacity: settings.opacity
          };
          $ripple.css(css);
        }
        // Ensure we always have the ripple element
        if (!settings.multi) {
          $ripple = $this.find(".ripple");
        }
        // Kill animation
        $ripple.removeClass("ripple-animate");
        // Retrieve coordinates
        let x = e.pageX - $this.offset().left - size / 2;
        let y = e.pageY - $this.offset().top - size / 2;
        /**
         * We want to delete the ripple elements if we allow multiple so we dont sacrifice any page
         * performance. We don't do this on single ripples because once it has rendered, we only
         * need to trigger paints thereafter.
         */
        if (settings.multi) {
          $ripple.one('animationend webkitAnimationEnd oanimationend MSAnimationEnd', function () {
            // eslint-disable-next-line babel/no-invalid-this
            $(this).remove();
          });
        }

        // Set position and animate
        $ripple.css({
          top: y + 'px',
          left: x + 'px',
          display: 'block'
        }).addClass("ripple-animate");
      };

      $(selector).on(self.defaults.on, self.selector, Trigger);
      $(selector).css({
        position: 'relative'
      })
    },

    /**
     * @description 处理显示在时间轴的素材的时长
     * 时间单位显示规则：小于60秒时以秒为单位，大于等于60秒时以分为单位，如2.0分，2.1分，3.9分等
     */
    handleResourceTime: function (time) {
      let useTime = this.handleTimeSecond(FJCoreUtil.toFixed(time, 2), 1);
      if (useTime < 60) {
        let s = Math.floor(useTime);
        return s + '.' + (useTime * 10 - s * 10) + 's';
      } else {
        let m = Math.floor(useTime / 60);
        let s = Math.floor(useTime % 60 / 60 * 10);
        return m + '.' + s + 'm'
      }
    },

    handleTimeLineFormat: function (changeTipsDuration, time) {
      let useTime = this.handleTimeSecond(FJCoreUtil.toFixed(time, 2), 1);
      if (useTime < 60) {
        let s = Math.floor(useTime);
        return changeTipsDuration + '.' + (useTime * 10 - s * 10);
      } else {
        return changeTipsDuration + '.' + Math.floor(useTime % 60 / 60 * 10);
      }
    },

    /**
     * @description 处理秒时间
     * @param time 秒时间
     * @param value 保留几位小数 -1 不处理
     */
    handleTimeSecond(time, value) {
      let v = value === -1 ? 1 : 10 * value;
      return Math.floor(time * v) / v;
    },

    /**
     * @description 返回选中的长度
     * @param myField
     * @return {number}
     */
    getSelectionLength: function (myField) {
      return myField.selectionEnd - myField.selectionStart;
    },

    /**
     * @description 在光标处插入
     * @param myField
     * @param myValue
     * @return {string}
     */
    insertAtCursor: function (myField, myValue) {
      // IE support
      if (document.selection) {
        myField.focus();
        let sel = document.selection.createRange();
        sel.text = myValue;
      }
      // MOZILLA and others
      else if (myField.selectionStart || Number(myField.selectionStart) === 0) {
        let startPos = myField.selectionStart;
        let endPos = myField.selectionEnd;
        myField.value = myField.value.substring(0, startPos)
          + myValue
          + myField.value.substring(endPos, myField.value.length);
      } else {
        myField.value += myValue;
      }

      return myField.value;
    },

    /**
     * @description 清除选中
     */
    clearSelection: function () {
      if (document.selection) {
        document.selection.empty()
      } else if (document.getSelection && document.getSelection()) {
        document.getSelection().removeAllRanges();
      }
    },

    /**
     * @description 对输入的字符串进行处理
     * @param str
     * @returns {void | string | *}
     */
    filterStr: function (str) {
      return str.replace(/<[^<>]+>/g, '')
      // return str.replace(/<script>|<\/script>/g, '')
    },

    testStr: function (str) {
      return /<[^<>]+>/g.test(str);
    },

    /**
     * @description 将内容中的指定内容替换为新的内容
     * @param str
     * @param replaceStr
     * @param replaceValue
     * @returns {*}
     */
    replaceStr: function (str, replaceStr, replaceValue = '') {
      return str.replace(replaceStr, replaceValue)
    },

    /**
     * @description 得到用户id
     * @returns {string}
     */
    getUerId: function () {
      let uid;
      if (this.isLogin()) { // 已登录
        uid = window.fjuser.info.id;
      } else { // 未登录
        uid = 'noLogin';
      }
      return uid;
    },

    /**
     * @description 返回是否登陆
     * @returns {*}
     */
    isLogin: function () {
      return window.fjuser && window.fjuser.isUserLogin()
    },

    /**
     * @description 显示注册面板
     * @returns {*}
     */
    showRegisterPanel: function () {
      if (window.fjuser && window.fjuser.showRegisterPanel) {
        window.fjuser.showRegisterPanel();
      }
    },

    /**
     * @description 隐藏所有面板
     */
    hideAllPanel: function () {
      FJCoreUtil.triggerEvent(document.body, 'mousedown');
      FJCoreUtil.triggerEvent(document.body, 'mousedown');
    },

    /**
     * @description 匿名工程处理
     * @return {Promise<unknown>}
     */
    dealAnonymousProject: function () {
      return new Promise(((resolve, reject) => {

        function func() {
          return new Promise((resolve1, reject1) => {

            let {SAVE_ONLINE_SUCCESS, SAVE_ONLINE_ERROR} = FJEventConstant;
            let unsubscribable1 = window.FJEvent.subscribe(SAVE_ONLINE_SUCCESS, () => {
              resolve1();
              unsubscribableAll();
            });
            let unsubscribable2 = window.FJEvent.subscribe(SAVE_ONLINE_ERROR, (e) => {
              reject1(e);
              unsubscribableAll();
            });

            function unsubscribableAll() {
              unsubscribable1();
              unsubscribable2();
            }

            FJCanvasStore.executeSync(FJCanvasStore.command.SAVE_FOR_ONLINE);

          });
        }

        if (FJUtil.isLocalhost()) {
          resolve();
        } else {
          if (FJUtil.isLogin()) {
            if (FJUtil.isAnonymousProject()) {
              func().then(resolve).catch(reject);
            } else {
              resolve();
            }
          } else {
            if (window.fjuser && window.fjuser.addListener && window.fjuser.eventType) {
              this.showRegisterPanel();
              let {login, register, hideRegisterPanel, hideLoginPanel} = window.fjuser.eventType;

              // eslint-disable-next-line no-inner-declarations
              function loginFunc(result) {
                removeUserListener();
                if (result) {
                  func().then(resolve).catch(reject);
                } else {
                  reject(result);
                }
              }

              // eslint-disable-next-line no-inner-declarations
              function registerFunc(result) {
                removeUserListener();
                if (result) {
                  func().then(resolve).catch(reject);
                } else {
                  reject(result);
                }
              }

              // eslint-disable-next-line no-inner-declarations
              function hideRegisterPanelFunc() {

                // 后台的监听逻辑在登录成功后会触发面板关闭的回调，所以此处需要异步处理避免登录回调被取消
                requestAnimationFrame(() => {
                  removeUserListener();
                })
                reject(new Error('NO LOGIN'));
              }

              // eslint-disable-next-line no-inner-declarations
              function hideLoginPanelFunc() {

                // 后台的监听逻辑在登录成功后会触发面板关闭的回调，所以此处需要异步处理避免登录回调被取消
                requestAnimationFrame(() => {
                  removeUserListener();
                })
                reject(new Error('NO LOGIN'));
              }

              // eslint-disable-next-line no-inner-declarations
              function addUserListener() {
                window.fjuser.addListener(login, loginFunc);
                window.fjuser.addListener(register, registerFunc);
                window.fjuser.addListener(hideRegisterPanel, hideRegisterPanelFunc);
                window.fjuser.addListener(hideLoginPanel, hideLoginPanelFunc);
              }

              // eslint-disable-next-line no-inner-declarations
              function removeUserListener() {
                window.FJEvent.dispatch('UPDATE_LOGIN_STATUS');
                window.fjuser.removeListener(login, loginFunc);
                window.fjuser.removeListener(register, registerFunc);
                window.fjuser.removeListener(hideRegisterPanel, hideRegisterPanelFunc);
                window.fjuser.removeListener(hideLoginPanel, hideLoginPanelFunc);
              }

              addUserListener();
            }
          }
        }
      }));
    },

    /**
     * @description 点击save
     */
    doSave: function () {
      if (FJUtil.isLocalhost()) {
        FJCanvasStore.executeSync(FJCanvasStore.command.SAVE_FOR_ONLINE);
        return
      }

      if (FJUtil.isLogin() && !FJUtil.isAnonymousProject()) {
        FJCanvasStore.executeSync(FJCanvasStore.command.SAVE_FOR_ONLINE);
      } else {
        FJUtil.dealAnonymousProject().catch((e) => {
          console.log(e)
        });
      }
    },

    /**
     * @description 统计
     * @param type
     * @param data
     */
    ealog: function (type, data) {
      console.log(type, data);
      if (window.ealog && window.ealog.addEvent) {
        window.ealog.addEvent(type, data);
      }
    },

    /**
     * @description 统计的时候获得上传文件的后缀
     * @param files
     * @returns {string}
     */
    getFilesTypes: function (files) {
      let typeList = [];
      for (let i = 0; i < files.length; i++) {
        typeList.push(files[i].type);
      }
      return typeList.join(',');
    },

    /**
     * @description 统计的时候获得上传文件的 最大size
     * @param files
     * @returns {number}
     */
    getFilesMaxSize: function (files) {
      let size = 0;
      for (let i = 0; i < files.length; i++) {
        size = files[i].size > size ? files[i].size : size;
      }
      return size / 1024;
    },

    getOSInfo: function () {
      let userAgent = navigator.userAgent.toLowerCase();
      let name = 'Unknown';
      let version = 'Unknown';
      if (userAgent.indexOf('win') > -1) {
        name = 'Windows';
        if (userAgent.indexOf('windows nt 5.0') > -1) {
          version = 'Windows 2000';
        } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
          version = 'Windows XP';
        } else if (userAgent.indexOf('windows nt 6.0') > -1) {
          version = 'Windows Vista';
        } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
          version = 'Windows 7';
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
          version = 'Windows 8';
        } else if (userAgent.indexOf('windows nt 6.3') > -1) {
          version = 'Windows 8.1';
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
          version = 'Windows 10';
        } else {
          version = 'Unknown';
        }
      } else if (userAgent.indexOf('iphone') > -1) {
        name = 'Iphone';
      } else if (userAgent.indexOf('mac') > -1) {
        name = 'Mac';
      } else if (userAgent.indexOf('x11') > -1 || userAgent.indexOf('unix') > -1 || userAgent.indexOf('sunname') > -1 || userAgent.indexOf('bsd') > -1) {
        name = 'Unix';
      } else if (userAgent.indexOf('linux') > -1) {
        if (userAgent.indexOf('android') > -1) {
          name = 'Android';
        } else {
          name = 'Linux';
        }
      } else {
        name = 'Unknown';
      }
      return {name, version};
    },

    /**
     * @description 根据type切换scope
     * @param type
     */
    toggleScope: function (type) {
      if (type === 'slideStart' || type === 'changeStart' || type === 'start') {
        _scope = key.getScope();
        key.setScope('');
      } else if (_scope && (type === 'slideStop' || type === 'changeEnd' || type === 'end')) {
        key.setScope(_scope);
      }
    },

    hashValue: function (value) {
      let hash = crypto.createHash('sha256');
      hash.update(value.toString());
      return hash.digest('hex');
    },

    setAuxiliary: function (ele) {
      auxiliary = ele;
    },
    getAuxiliary: function () {
      return auxiliary;
    },

    /**
     * @description 检查浮点数是否可以相等
     * @param v1
     * @param v2
     * @return {boolean}
     */
    checkFloatEqual: function (v1, v2) {
      return Math.abs(v1 - v2) < 0.0001;
    },

    /**
     * @description svg字符串转dom
     * @param svgStr
     * @return {null}
     */
    decodeSvg: function (svgStr) {
      let car = document.createElement("div");
      car.innerHTML = svgStr;
      let svg = null;
      if (car.childNodes.length === 1)
        svg = car.firstChild;
      else {
        for (let i = 0; i < car.childNodes.length; i++) {
          let ele = car.childNodes[i];
          if (ele.localName === "svg") {
            svg = ele;
            break;
          }
        }
      }

      return svg;
    },
    parseSVGWithStyle: function (svg) {
      let styleDatas = [];
      $(svg).find("*").each(function (index, ele) {
        if (ele.getAttribute("display") === "none") {
          if (ele.remove) {
            ele.remove();
          } else {
            ele.parentNode.removeChild(ele);
          }
        } else if (ele.localName !== "g" && ele.localName !== "defs" && ele.localName !== "title") {
          if (ele.localName === "style") {
            let data = {};
            let styleString = ele.textContent;
            let styleName = styleString.substring(1, styleString.indexOf("{"));
            let style = styleString.substr(styleString.indexOf("{") + 1, styleString.length - 2);
            let datas = style.split(";");
            data.styleName = styleName;
            for (let i = 0; i < datas.length; i++) {
              let styleData = datas[i];
              let keyValue = styleData.split(":");
              if (keyValue.length !== 2)
                continue;
              let key = keyValue[0];
              let value = keyValue[1];
              data[key] = value;
            }
            styleDatas.push(data);
          } else {
            if (ele.hasAttribute("class")) {
              let styleName = ele.getAttribute("class")
              for (let i = 0; i < styleDatas.length; i++) {
                let sd = styleDatas[i];
                if (sd.styleName === styleName) {
                  for (let key in sd) {
                    if (key === "styleName")
                      continue;
                    if (typeof sd[key] !== 'undefined')
                      ele.setAttribute(key, sd[key]);
                  }
                  break;
                }
              }
            }
          }
        }
      });
    },
    svgConvertToCompoundPathSVG: function (svg) {
      let oldWidth = 0;
      let oldHeight = 0;
      let vb = svg.getAttribute("viewBox");
      if (vb) {
        let sv = vb.split(" ");
        oldWidth = sv.length === 4 ? sv[2] : 0;
        oldHeight = sv.length === 4 ? sv[3] : 0;
      }

      paper.project.clear();
      let paths = [];
      $(svg).find("*").each(function (index, ele) {
        if (ele.localName === "path") {
          let pathData = ele.getAttribute("d");

          // eslint-disable-next-line new-cap
          paths.push(new paper.PathItem.create(pathData));
        } else if (ele.localName === "rect") {
          let x = ele.hasAttribute("x") ? parseFloat(ele.getAttribute("x")) : 0;
          let y = ele.hasAttribute("y") ? parseFloat(ele.getAttribute("y")) : 0;
          let width = ele.hasAttribute("width") ? parseFloat(ele.getAttribute("width")) : 0;
          let height = ele.hasAttribute("height") ? parseFloat(ele.getAttribute("height")) : 0;
          paths.push(new paper.Path.Rectangle([x, y], [width, height]));
        } else if (ele.localName === "circle") {
          let cx = ele.hasAttribute("cx") ? parseFloat(ele.getAttribute("cx")) : 0;
          let cy = ele.hasAttribute("cy") ? parseFloat(ele.getAttribute("cy")) : 0;
          let r = parseFloat(ele.getAttribute("r"));
          paths.push(new paper.Path.Circle({
            center: [cx, cy],
            radius: r
          }));
        } else if (ele.localName === "ellipse") {
          let cx = ele.hasAttribute("cx") ? parseFloat(ele.getAttribute("cx")) : 0;
          let cy = ele.hasAttribute("cy") ? parseFloat(ele.getAttribute("cy")) : 0;
          let rx = parseFloat(ele.getAttribute("rx"));
          let ry = parseFloat(ele.getAttribute("ry"));
          paths.push(new paper.Path.Ellipse({
            point: [cx - rx, cy - ry],
            size: [2 * rx, 2 * ry],
          }));
        } else if (ele.localName === "line") {
          let x1 = parseFloat(ele.getAttribute("x1"));
          let y1 = parseFloat(ele.getAttribute("y1"));
          let x2 = parseFloat(ele.getAttribute("x2"));
          let y2 = parseFloat(ele.getAttribute("y2"));
          paths.push(new paper.Path.Line({
            from: [x1, y1],
            to: [x2, y2],
          }));
        } else if (ele.localName === "polygon") {
          let pointData = ele.getAttribute("points");
          let pts = pointData.split(" ");
          let pointArray = [];
          for (let i = 0; i < pts.length; i++) {
            let pt = pts[i];
            if (pt.indexOf(",") === -1)
              continue;
            let ptString = pt.split(",");
            let x = parseFloat(ptString[0]);
            let y = parseFloat(ptString[1]);
            let pA = [x, y];
            pointArray.push(pA);
          }
          paths.push(new paper.Path({
            segments: pointArray,
            closed: true
          }));
        } else if (ele.localName === "polyline") {
          let pointData = ele.getAttribute("points");
          let pts = pointData.split(" ");
          let pointArray = [];
          for (let i = 0; i < pts.length; i++) {
            let pt = pts[i];
            if (pt.indexOf(",") === -1)
              continue;
            let ptString = pt.split(",");
            let x = parseFloat(ptString[0]);
            let y = parseFloat(ptString[1]);
            let pA = [x, y];
            pointArray.push(pA);
          }
          paths.push(new paper.Path({
            segments: pointArray,
            closed: false
          }));
        }
      });
      $(svg).empty();
      let compoundPath = new paper.CompoundPath({
        children: paths,
      });
      let bounds = compoundPath.bounds;
      let offsetX = bounds.x;
      let offsetY = bounds.y;
      let w = bounds.width;
      let h = bounds.height;
      if ((oldWidth !== 0 && oldHeight !== 0) && (Math.abs(w - oldWidth) > 1000 || Math.abs(h - oldHeight) > 1000))
        return null;
      svg.setAttribute("viewBox", "0 0 " + w + " " + h);
      svg.setAttribute("width", w);
      svg.setAttribute("height", h);
      let p = document.createElementNS("http://www.w3.org/2000/svg", "path");
      p.setAttribute("transform", "translate(" + -offsetX + "," + -offsetY + ")");
      p.setAttribute("d", compoundPath.pathData);
      p.setAttribute("fill", "#000000");
      p.setAttribute("class", "fill c1");
      svg.appendChild(p);
      return {width: w, height: h};
    },
    isIneffectivenessSVG: function (svg) {
      let result = false;
      let arr = $(svg).find("*");
      if (arr.length === 0)
        return true;
      for (let i = 0; i < arr.length; i++) {
        let ele = arr[i];
        if ((ele.hasAttribute("stroke") && ele.getAttribute("stroke") !== "none") ||
          (ele.hasAttribute("fill") && ele.getAttribute("fill") === "none") ||
          ele.hasAttribute("transform")) {
          result = true;
          break;
        }
      }

      return result;
    },
    /**
     * @description 当前浏览器是否支持
     * @return {boolean}
     */
    isSupportBrowser: function () {
      return !!FJConfig.supportBrowser.find(item => item === FJCoreUtil.getBrowser());
    },
    loadImage: function (src, oriImage) {
      return new Promise((resolve, reject) => {
        let image = oriImage || new Image();
        image.setAttribute('crossOrigin', 'anonymous');
        image.onload = () => resolve(image);
        image.onerror = () => reject(image);
        image.onabort = () => reject(image);
        image.src = src;
      });
    },
    /**
     * 压缩图片方法,压缩后的图片宽高至少一项不超过输入尺寸
     * @param inFile 待压缩的文件
     * @param compressWidth
     * @param compressHeight
     * @return {Promise<void>}
     */
    compressImage: async function (inFile, compressWidth, compressHeight) {
      try {

        if (!compressWidth || !compressHeight) {
          return inFile;
        }

        let dataUrl = URL.createObjectURL(inFile);
        let img = await this.loadImage(dataUrl);
        let innerSize = {
          width: img.naturalWidth,
          height: img.naturalHeight,
        };
        let outerSize = {
          width: Math.min(innerSize.width, compressWidth),
          height: Math.min(innerSize.height, compressHeight),
        };
        let outSize = FJCoreUtil.fitSize(outerSize, innerSize);
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        canvas.width = outSize.width;
        canvas.height = outSize.height;
        ctx.drawImage(img, 0, 0, outSize.width, outSize.height);
        let blob = await new Promise((resolve) => {
          canvas.toBlob((blob) => {
            resolve(blob);
          });
        })
        return blob;
      } catch (e) {
        throw new Error(FJErrorConstant.COMPRESS_FAIL);
      }
    },

    /**
     * @description 与localstorage交互
     * @param key
     * @param value
     * @return {string}
     */
    localStorageFunc: function (key, value) {
      if (typeof value === 'undefined') {
        return localStorage.getItem(key);
      } else {
        localStorage.setItem(key, value);
      }
    },

    random: function (array, count) {
      let arr = [];
      for (let i = 0; i < count; i++) {
        let index = Math.floor(Math.random() * array.length);
        arr.push(array[index]);
        array.splice(index, 1);
      }
      return arr;
    },

    getFormat: function (downloadFormatDetails) {
      if (downloadFormatDetails) {
        let {videoFormatList, videoResolutionList} = FJConfig;
        let format = videoFormatList.find(item => downloadFormatDetails[item]);
        let formatDetail = downloadFormatDetails[format];
        let result = videoResolutionList.find(resolution => formatDetail.width === resolution.width
          && formatDetail.height === resolution.height);
        return result && result.tag;
      }
    },

    addSearchHistory: function (key, searchValue, maxCount = 8) {
      let value = searchValue;
      if (value.trim() === '') {
        return;
      }
      value = value.trim().toLowerCase();
      let history = this.localStorageFunc(key);
      history = history ? JSON.parse(history) : [];
      if (history.includes(value)) {
        let index = history.indexOf(value);
        history.splice(index, 1);
        history = [
          value,
          ...history,
        ]
      } else {
        history.unshift(value);
      }
      this.localStorageFunc(key, JSON.stringify(history.slice(0, maxCount)));
      window.FJEvent.dispatch(key);
    },
    getSearchHistory: function (key) {
      let history = this.localStorageFunc(key);
      history = history ? JSON.parse(history) : [];
      return history;
    },
    clearSearchHistory: function (key) {
      this.localStorageFunc(key, []);
      window.FJEvent.dispatch(key);
    },

	  getStatusWithStockSearch: function (mode, total, listLength) {
		  const {STOCK_SEARCH_LOADING, STOCK_SEARCH_SUBLOADING, STOCK_SEARCH_ERROR, STOCK_SEARCH_NONE, STOCK_SEARCH_END} = FJViewConstant;
		  let searchStatus = '';
		  if (total === 0) {
			  searchStatus = STOCK_SEARCH_NONE;
		  } else if (total <= listLength) {
			  searchStatus = STOCK_SEARCH_END;
		  }
		  switch (mode) {
			  case STOCK_SEARCH_LOADING:
				  searchStatus = STOCK_SEARCH_LOADING;
				  break;
			  case STOCK_SEARCH_ERROR:
				  searchStatus = STOCK_SEARCH_ERROR;
				  break;
			  case STOCK_SEARCH_SUBLOADING:
				  searchStatus = STOCK_SEARCH_SUBLOADING;
				  break;
		  }

		  return searchStatus;
	  },

	  formatNumber: function (number) {
		  let a = number;
		  let b = "";
		  while (Math.floor(a / 1000) !== 0) {
			  let c = a / 1000;
			  let d = c - Math.floor(c);
			  b = ","+ d.toFixed(3).replace("0.","") + b;
			  a = Math.floor(c);
		  }

		  return a + b;
	  },

	  /**
	   * @description 去掉字符串的无效字符
	   * @param value
	   * @return {*}
	   */
	  filterInvalidWord: function (value) {
		  let _value = value;
		  _value = _value.replace(/[`~!@#$%^&*()_+<>?:"{},.\/;\-[\]]/g, ' ');
		  _value = (_value.trim()).replace(/\s+/g, ' ');
		  return _value;
	  },

    /**
     * @description 根据尺寸类型、提供的尺寸计算比例下的尺寸
     * @param preSize
     * @param ratioType
     * @return {{width: number, height: number}|*}
     */
    calcSizeWithRatioType: function (preSize, ratioType = FJViewConstant.RATIO_LANDSCAPE) {
	    let {width, height} = preSize;
	    if (width && height) {
	      return {...preSize};
      }

	    let ratioKey = FJRatioStore.ratioKeyWithRatioType(ratioType);
	    let {width: ratioWidth, height: ratioHeight} = FJRatioStore.allRatioSize()[ratioKey];

	    if (!width) {
	      width = this.even(Math.floor(height * ratioWidth / ratioHeight));
      }

	    if (!height) {
	      height = this.even(Math.floor(width * ratioHeight / ratioWidth));
      }

	    return {width, height};
    },

    /**
     * 获取媒体素材在s3上的key
     * @param media
     * @returns {string}
     */
    getS3Key: function (media) {
      // 组合上传云端的路径，格式为：/media/{uid}/{video/audio/photo}/{media.id.ext}
      let uid = (window.fjuser && window.fjuser.info) ? window.fjuser.info.id : 1594;
      let fileName = media.name;
      let ext = fileName.substring(fileName.lastIndexOf('.'));
      let type = "photo";
      if(media.type === FJMedia.MediaType().VIDEO)
      {
        type = "video"
      }
      else if(media.type === FJMedia.MediaType().AUDIO)
      {
        type= "audio"
      }
      return "media/"+uid + "/" + type + "/" + media.id+ext;
    },

    /**
     * 获取媒体封面在s3上的key
     * @param media
     * @returns {string}
     */
    getS3CoverKey: function (media) {
      // 组合上传云端的路径，格式为：/media/{uid}/{video/audio/photo}/cover/{media.id.ext}
      let uid = (window.fjuser && window.fjuser.info) ? window.fjuser.info.id : 1594;
      let type = "photo";
      if(media.type === FJMedia.MediaType().VIDEO)
      {
        type = "video"
      }
      else if(media.type === FJMedia.MediaType().AUDIO)
      {
        type= "audio"
      }
      return "media/"+uid + "/" + type + "/cover/" + media.id + '.png';
    },

    /**
     * @description dataURLToBlob
     * @param dataurl, Canvas.toDataURL()返回的对象
     * @returns {Blob}
     */
    dataURLToBlob: function (dataurl) {
      if(!dataurl)
        return new Blob();

      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type:mime});
    },

    getPathSuffix: function (path) {
      return path.substr(path.lastIndexOf('.') + 1).trim();
    },
  }
})();

export default FJUtil;
